var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetski(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.78 73.8429C127.191 81.6882 122.368 82.914 103.491 82.3416C88.3881 81.8844 51.1603 80.6532 34.2708 80.1357L29.1222 68.0406",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.913 45.3402C103.846 43.2047 102.244 42.137 99.567 41.0711C100.766 39.8726 103.604 37.7041 105.369 38.6194C107.576 39.7636 114.076 43.2971 115.057 45.3402",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0484 49.4891C85.5109 52.4312 83.6384 53.0898 79.4633 50.3063C77.7471 49.1623 77.3385 48.6719 77.3385 48.6719L52.5944 45.8742L60.0684 51.7466C63.2716 51.7466 65.9409 53.3483 65.9409 57.0852",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.917 45.2396H99.8127L94.7457 47.9365L94.2561 49.4892C102.02 50.5517 117.465 54.1475 130.786 59.1327",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4082 62.1546C51.6226 59.9482 58.9015 55.666 62.3011 56.189C66.5508 56.8428 100.875 64.1166 119.344 61.1745",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.63 67.9578H24.3V65.8329C37.3757 61.7469 64.0993 61.0935 69.9834 61.9917C75.8675 62.8908 101.692 66.2415 121.96 60.5211C138.173 55.9445 151.162 63.5721 155.63 67.9578ZM155.63 67.9578C153.98 65.6106 150.281 61.8891 144.516 58.2869M144.516 58.2869C140.511 50.0867 123.594 41.7248 121.224 40.5807C119.917 39.9495 120.897 42.2148 121.96 43.8495L120.406 43.4408M144.516 58.2869C138.572 54.5736 130.433 50.9869 120.08 49.1618C119.727 48.1386 119.74 46.9327 119.868 45.8926M120.406 43.4408C122.695 43.904 128.71 46.0723 134.464 51.0411C134.464 51.0411 132.323 48.1809 119.868 45.8926M120.406 43.4408C120.406 43.4408 120.037 44.5232 119.868 45.8926",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3179 62.8917C42.4156 59.4862 48.0164 52.8227 53.6389 53.4114C56.5809 53.7194 58.4606 54.4738 59.9316 56.4352",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.851 67.9578C151.925 69.2106 149.044 72.2562 144.924 74.4135C143.29 73.0248 137.65 72.0438 131.359 73.4334C125.066 74.8221 111.172 78.0099 82.079 76.7022",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetski);
export default __webpack_public_path__ + "static/media/jetski.15ff92effee93f725e40bd500c41eb2a.svg";
export { ForwardRef as ReactComponent };